export const constants = {
    SOCKETIO_CONNECT: 'SOCKETIO_CONNECT',
    SOCKETIO_DISCONNECT: 'SOCKETIO_DISCONNECT',
    SOCKETIO_ON_CONNECT: 'SOCKETIO_ON_CONNECT',
    SOCKETIO_ON_DISCONNECT: 'SOCKETIO_ON_DISCONNECT',
}